// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__2Yt4g","container":"styles_container__Wbm8H","appPlay":"styles_appPlay__--+IX"};